
<div>
  <input
    :id="inputId"
    :name="name"
    :aria-describedby="ariaDescribedByName"
    type="checkbox"
    :checked="shouldBeChecked"
    :value="value"
    :class="checkboxClasses"
    :disabled="isDisabled"
    :tabindex="tabIndex"
    :required="required"
    @change="updateInput"
    @blur="$emit('blur')"
    @click="removeMouseFocus"
  />
  <label :class="checkboxLabelClasses" :for="inputId" :aria-label="ariaLabel">
    {{ labelName }}
    <span v-if="formattedLabelText" v-html="formattedLabelText"></span>
  </label>
  <HelperText v-if="helperText" :id="inputId" :text="helperText" :status="status" />
</div>
